module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/recommend_2_01-3c9f75e62d55fb94378c804205530440.jpg";